module.exports = __webpack_public_path__ + "media/home/interview-content-84dddd4d.png";